import { Common } from './Common.js';
import DialogMgr from './DialogMgr.js';
import EventFrequenciesVM, {  EventFrequencyChartVM, EventFrequencyBlockSelector } from './EventFrequenciesChart.js';
import { FrequencyDataForGraph, FrequencyDataDetailed, AssignFrequenciesConst, FrequencyUseConflictType } from './AssignFrequenciesEntities.js';
import { FrequencyChartColors } from './FrequencyChart.js';
import { ActivityAssignment } from './AssignFrequenciesEntities.js';
import moment from 'moment/moment.js';

var EventsAllFrequenciesVM = function (model) {
  var self = this;
  if (RazorShared.isDebug) Common.LogConsole('EventsAllFrequenciesVM');
  self.EventIDs = model.EventIDsList.split(",").map(function (evId) { return  new Number(evId) });
  //self.EventID = model.FrequenciesData.Frequencies[0].EventID;
  self.MultipleEvents = true;
  self.$container = $(document);
  self.$form = $('');
  self.FrequenciesData =  ko.observable(model.FrequenciesData || []);
  self.EventsDataBasic = ko.observableArray(model.EventsDataBasic);
  self.FrequenciesViewModel = ko.observableArray(model.FrequenciesViewModel || []);
  self.SegmentsInfo = ko.observableArray();
  self.SelectedSegmentInfo = ko.observable(null);
  self.Frequencies = ko.observableArray([]);
  self.ScanData = ko.observableArray();
  self.ScanColors = model.FrequenciesViewModel[0].AvailScanColors;
  self.ChartMinFreq = ko.observable(model.EventsDataBasic[0].Frequency || null);
  self.ChartMaxFreq = ko.observable(model.EventsDataBasic[model.EventsDataBasic.length-1].Frequency || null);
  self.chart = null;  
  self.ShowSpectrumData = ko.observable(false);
  self.FrequencyEventDetails = ko.observableArray();
  self.SelectedFrequencyEventDetail = ko.observable(0);
  self.EventFrequencyBlockSelector = new EventFrequencyBlockSelector(self.GetEventFrequencies);

  self.SelectSegment = function(){
    self.GetEventFrequencies();
  }

  self.SegmentInfoIndex = function(segInfo){   
    return ko.utils.arrayIndexOf(self.SegmentsInfo(), segInfo);
  }

  self.SelectionMask = ko.pureComputed(function () {
    var mask = 0;
    if (self.AllActivities.length > 0)
      self.AllActivities.forEach(function (a) {
        mask += a.BitFlag;
      });
    return mask;
  });

  self.formatDate = function(dtStr){
    return moment(dtStr).format("MM-DD-YYYY");
  }

  self.MakeSelectionMask = function (conflictIDs) {
    var bitmask = 0;
    if (conflictIDs) {
      conflictIDs.forEach(function (id) {
        var act = self.AllActivities.find(function (a) {
          return a.ActivityID == id;
        });
        if (act) bitmask += act.BitFlag;
      });
    }
    return bitmask;
  };


  self.AllActivities = (model.FrequenciesViewModel || []).map(function (a) {   
    return new ActivityAssignment(a.Activities);
  });

  self.DistinctActivityLocations = ko.pureComputed(function () {
    var sortedActivities = self.AllActivities.sort(Common.StringSortFunc('LocationName')) || [];
    var distinctDisplayedLocations = Array.from(
      new Set(
        sortedActivities.map(function (a) {
          return a.LocationID;
        })
      )
    ).map(function (id, idx) {
      return {
        ID: id,
        Name: sortedActivities.find(function (l) {
          return l.LocationID === id;
        }).LocationName,
        ChartColor: self.ScanColors[idx]
      };
    });
    return distinctDisplayedLocations;
  });
  self.resetSelectedFreqBlockSegment = ko.observable(true);
 

  self.FrequencyDataReceived = function (freqData, scanData, keepCurrentZoom) {
    var assignmentCallback = null;
    var zoomchart = self.Frequencies().length == 0 && !keepCurrentZoom; // reset zoom if starting from scratch

    self.FrequenciesData(freqData);
    self.ScanData(scanData);

    var frequencies = (freqData || []).map(function (f) {
      return new FrequencyDataForGraph(f, 0, self.MakeSelectionMask, null, FrequencyGraphItemBuilder, true);
    });

    self.Frequencies(
      frequencies.sort(function (l, r) {
        return l.Frequency == r.Frequency ? 0 : l.Frequency < r.Frequency ? -1 : 1;
      })
    );
    self.RefreshFrequencies(zoomchart);

  };

  self.ChartData = function () {    
    var data = self.Frequencies().map(function (f) {
      return f.GraphItem;
    });

    //loop thru scan data
    if (self.ShowSpectrumData()) {
      var previousFrequencies = [];
      var locationIDs = self.SelectedScanLocations();
      var previousLocationId = [];
      var foundCount = 0;
      var addedCount = 0;

      var range = $('#hdnSpectrumScanFrequencyRange').val();
      if (range == null || range == '') range = '0.05';

      $.each(data, function (o, graphItem) {
        //find frequency in scanData for each location
        $(locationIDs).each(function (o, locationId) {
          $(self.ScanData()).each(function (o, sc) {
            //spectrumScan
            if (sc.LocationID == locationId) {
              var d = $.grep(sc.Frequencies, function (f) {
                //frequency
                //frequency difference must be within range for match
                //multiple by 10000 because javascript can't handle precision math
                var factor = 10000;
                var diff = parseFloat(f.Frequency) * factor - parseFloat(graphItem.Frequency) * factor;
                return Math.abs(diff) <= parseFloat(range) * factor;
              });

              if (d.length > 0) {
                //Frequency found
                graphItem['SignalStrength_' + locationId] = d[0].GraphPosition;

                foundCount++;
                d[0]['Added'] = true;

                return false;
              }
            }
          });
        });
      });

      //add missing frequencies (DISABLED, just log count that is missing)
      $(self.ScanData()).each(function (o, sc) {
        var missing = $.grep(sc.Frequencies, function (f) {
          return !f.Added;
        });

        $(missing).each(function (o, f) {
          if ($.inArray(f.Frequency, previousFrequencies) == -1) {
            var graphItem = {
              Frequency: f.Frequency,
              MaxVal: 100,
              Value: 0,
              Color: '',
              OwnValue: 0,
              OwnColor: '',
              OwnBorder: '',
              OwnAlpha: 0,
              SBValue: 0,
              SBColor: '',
              PendingValue: 0,
              ClickFunc: null,
              BalloonText: ''
            };

            //graphItem['SignalStrength_' + sc.LocationID] = f.GraphPosition;
            //data.push(graphItem);
            previousFrequencies.push(f.Frequency);

            addedCount++;

            //Common.LogConsole('Added [' + f.Frequency + ']');
          } else {
            //frequency already added, find and update position for location
            var items = $.grep(data, function (g) {
              return g.Frequency == f.Frequency;
            });

            if (items.length > 0) {
              //var graphItem = items[0];
              //graphItem['SignalStrength_' + sc.LocationID] = f.GraphPosition;
            }
          }
        });
      });

      Common.LogConsole('[' + foundCount + '] frequencies were found');
      //Common.LogConsole('[' + addedCount + '] frequencies were added');
      Common.LogConsole('[' + addedCount + '] frequencies missing');
    }

    return data.sort(function (l, r) {
      return l.Frequency == r.Frequency ? 0 : l.Frequency < r.Frequency ? -1 : 1;
    });
  };


  self.ClearFrequencies = function () {
    self.Frequencies([]);
    self.RefreshChart();
  };

  self.RefreshFrequencies = function (rezoom) {
    self.Frequencies().forEach(function (f) {
      f.ApplyFilter(self.SelectionMask());
    });
    self.RefreshChart(rezoom);
  };
  
  self.InfoFrequency = ko.observable(null);
  self.InfoDetail = ko.observable(false);
  self.InfoXCoord = ko.observable(0);

  self.SetInfoFrequency = function (frequency, screenX, detail) {       
    if (detail) {
      self.ClearInfoFrequency();
      self.GetFreqNoteDetail(frequency);
    } else if (!self.InfoDetail()) {
      //  if detail box currently displayed, don't replace it except with another detail box
      var freqVM = self.Frequencies().find(function (f) {
        return f.Frequency == frequency;
      });
      if (freqVM) {
        self.InfoXCoord(screenX);
        self.InfoDetail(false);
        self.InfoFrequency(freqVM);        
      } else {
        self.ClearInfoFrequency();
      }
    }
  };

  self.ClearInfoFrequency = function () {
    self.InfoFrequency(null);
    self.InfoXCoord(0);
    self.InfoDetail(false);
  };

  var FrequencyGraphItemBuilder = function (freqData) {
    var graphItem = {
      Frequency: freqData.FrequencyDisplay,
      MaxVal: 100,
      Value: 0,
      Color: '',
      OwnValue: 0,
      OwnColor: '',
      OwnBorder: '',
      OwnAlpha: 0,
      SBValue: 0,
      SBColor: '',
      PendingValue: 0,
      ImodValue: 0,
      ClickFunc: true, //freqData.ToggleAssignment,
      BalloonText: freqData.BalloonText
    };

    var GetGraphValue = function (val) {
      if (val > 0 && val < AssignFrequenciesConst.MinGraphHeight) return AssignFrequenciesConst.MinGraphHeight;
      if (val > AssignFrequenciesConst.MaxGraphHeight) return AssignFrequenciesConst.MaxGraphHeight;
      return val;
    };

    if (freqData.OtherEquipmentUses && freqData.OtherEquipmentUses.length > 0) {
      // has something for current equipment
      graphItem.OwnValue = graphItem.MaxVal;
      graphItem.SBValue = graphItem.OwnValue;
      graphItem.OwnAlpha = FrequencyChartColors.ItemBaseAlpha * 0.5;

      switch (freqData.OtherEquipmentUses[0].FrequencyUseConflictTypeID) {
        case FrequencyUseConflictType.AssignedCenter:
          graphItem.OwnColor =
            freqData.CurrentEquipmentAssigned && freqData.CurrentEquipmentAssigned.DisplayColor
              ? freqData.CurrentEquipmentAssigned.DisplayColor
              : FrequencyChartColors.ColorTaken;
          graphItem.OwnBorder = FrequencyChartColors.StrokeAssigned;
          graphItem.OwnAlpha = FrequencyChartColors.ItemBaseAlpha;
          graphItem.SBColor = graphItem.OwnColor;
          break;
        case FrequencyUseConflictType.AssignedBandwidth:
          graphItem.OwnColor = FrequencyChartColors.ColorOverlap;
          graphItem.OwnBorder = FrequencyChartColors.StrokeAssigned;
          graphItem.SBColor = graphItem.OwnColor;
          break;
        case FrequencyUseConflictType.Spacing:
        case FrequencyUseConflictType.Intermod:
          graphItem.OwnColor = FrequencyChartColors.ColorOverlap;
          graphItem.OwnBorder = FrequencyChartColors.StrokeWithin;
          graphItem.SBColor = graphItem.OwnColor;
          break;
        case FrequencyUseConflictType.Pending:
        case FrequencyUseConflictType.Other:
          graphItem.OwnColor = FrequencyChartColors.ColorOpen;
          graphItem.OwnBorder = FrequencyChartColors.StrokePending;
          graphItem.SBColor = '';
          graphItem.SBValue = 0;
          break;
        default:
          graphItem.OwnValue = 0;
          graphItem.OwnColor = '';
          graphItem.OwnBorder = '';
          graphItem.SBColor = '';
          graphItem.SBValue = 0;
          break;
      }
      if (freqData.ShowIModInGraph) {
        graphItem.ImodValue = '30';
        //graphItem.OwnAlpha = FrequencyChartColors.ItemBaseAlpha * 1;
        graphItem.OwnBorder = FrequencyChartColors.StrokeWithin;
        graphItem.SBValue = '30';
        graphItem.SBColor = FrequencyChartColors.ColorImodInRange;
      }
    } else if (freqData.ImodActive.length) {
      graphItem.OwnValue = graphItem.MaxVal;
      graphItem.SBValue = graphItem.OwnValue;
      graphItem.OwnAlpha = FrequencyChartColors.ItemBaseAlpha * 0.5;
      graphItem.OwnColor = FrequencyChartColors.ColorOverlap;
      graphItem.OwnBorder = FrequencyChartColors.StrokeWithin;
      graphItem.SBColor = graphItem.OwnColor;
    } else if (freqData.ShowIModInGraph && freqData.OtherEquipmentUses.length == 0) {
      graphItem.ImodValue = '30';
      graphItem.OwnAlpha = FrequencyChartColors.ItemBaseAlpha * 1;
      graphItem.OwnColor = FrequencyChartColors.ColorImodInRange;
      graphItem.OwnBorder = '';
      graphItem.SBValue = '';
      graphItem.SBColor = '';
    } else {
      // nothing for current equipment
      graphItem.OwnValue = 0;
      graphItem.OwnAlpha = FrequencyChartColors.ItemBaseAlpha * 0.5;
      graphItem.OwnColor = '';
      graphItem.OwnBorder = '';
      graphItem.SBColor = '';
      graphItem.SBValue = 0;
    }

    var otherPower = 0,
      TVPower = 0,
      otherVal = 0,
      TVVal = 0,
      otherColor = '',
      TVColor = '';
    if (freqData.ActiveTVUses.length > 0) {
      TVPower =
        freqData.ActiveTVUses.map(function (x) {
          return x.Power;
        }).reduce(function (max, cur) {
          return Math.max(max, cur);
        }, 1) * AssignFrequenciesConst.TVPowerGraphFactor;
      TVVal = GetGraphValue(TVPower);

      if (freqData.ActiveTVUses[0].DisplayColor) TVColor = freqData.ActiveTVUses[0].DisplayColor;
      else if (freqData.ActiveTVUses[0].IsHighPower) TVColor = FrequencyChartColors.ColorTVHigh;
      else TVColor = FrequencyChartColors.ColorTVLow;
    }

    if (freqData.OtherEquipmentActive.length > 0) {
      otherPower =
        freqData.OtherEquipmentActive.map(function (x) {
          return x.Power;
        }).reduce(function (max, cur) {
          return Math.max(max, cur);
        }, 1) * AssignFrequenciesConst.EquipPowerGraphFactor;
      otherVal = GetGraphValue(otherPower);

      if (freqData.OtherEquipmentThisAssigned.length > 0)
        otherColor = freqData.OtherEquipmentThisAssigned[0].DisplayColor
          ? freqData.OtherEquipmentThisAssigned[0].DisplayColor
          : FrequencyChartColors.ColorTaken;
      else otherColor = FrequencyChartColors.ColorOverlap;
    }

    if (otherPower > 0 && TVPower > 0 && graphItem.OwnValue == 0) {
      // "borrow" own equipment graph to show both
      graphItem.OwnValue = TVVal;
      graphItem.OwnAlpha = FrequencyChartColors.ItemBaseAlpha * 2;
      graphItem.OwnColor = TVColor;
      graphItem.OwnBorder = '';

      graphItem.Value = otherVal;
      graphItem.Color = otherColor;

      if (TVPower > otherPower) {
        graphItem.SBColor = TVColor;
        graphItem.SBValue = TVVal;
      } else {
        graphItem.SBColor = otherColor;
        graphItem.SBValue = otherVal;
      }
    } else if (TVPower > otherPower) {
      // show TV if stronger than other equip
      graphItem.Value = TVVal;
      graphItem.Color = TVColor;
    } else if (otherPower > 0) {
      // show other equipment if TV not stronger
      graphItem.Value = otherVal;
      graphItem.Color = otherColor;
    } else {
      // nothing to show
      graphItem.Value = 0;
      graphItem.Color = FrequencyChartColors.ColorOpen;
    }

    if (graphItem.SBValue == 0) {
      graphItem.SBValue = graphItem.Value;
      graphItem.SBColor = graphItem.Color;
    }

    graphItem.PendingValue = graphItem.Value == 0 ? freqData.OtherEquipmentPending.length * AssignFrequenciesConst.PendingCountGraphFactor : 0;

    return graphItem;
  };
  self.FrequencyGraphItemBuilder = FrequencyGraphItemBuilder;

  self.RefreshFrequencies = function (rezoom) {
    self.Frequencies().forEach(function (f) {
      f.ApplyFilter(0);
    });
    self.RefreshChart(rezoom);
  };

  self.RefreshChart = function (rezoom) {
    Common.LogConsole('RefreshChart');

    if (self.chart) {
      self.chart.Refresh();
      if (rezoom) {
        self.chart.zoomChart();
        self.lastAjaxMethod = null;
      }
    }
  };

  self.LoadChart = function () {
    var locationIDs = [];
    var sortedLocations = self.AllActivities.sort(Common.StringSortFunc('LocationName'));
    locationIDs = Array.from(
      new Set(
        sortedLocations.map(function (a) {
          return a.LocationID;
        })
      )
    );

    var locationAndScanColors = locationIDs.reduce(function (result, item, idx) {
      result[item] = self.ScanColors[idx];
      return result;
    }, {});

    self.chart = new EventFrequencyChartVM(self.ChartData, self.SetInfoFrequency, locationIDs, locationAndScanColors, true);
    //$(".frequencyChart-chart-div").remove("a");
    self.SelectionMask.subscribe(function () {
      self.RefreshFrequencies();
    });
  };

  
  self.GetFreqNoteDetail = function (frequency) {      
    let params = {
      procsID: self.EventIDs,
      frequency: frequency
    };

    Common.BlockUI();
    $.post(RazorShared.baseUrl + 'AssignFrequencies/EventsFrequencyDetail', params, function (data) {
      $.unblockUI();
      if (data.success) {
        var v = data.freqDetails;  
        self.FrequencyEventDetails(v);    
        self.SelectedFrequencyEventDetail(0);
        self.ChangeInfoEvent();
      } else {
        Common.Dialog('Error Retrieving Frequency Detail', null, data.error);
      }
    }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
      $.unblockUI();
      Common.Dialog('Error Retrieving Frequency Detail', textStatus + '/' + errorThrown, null, XMLHttpRequest.status);
    });
  };

  self.IncrementInfoEvent = ko.pureComputed(function(){
    let e = self.SelectedFrequencyEventDetail();
    if(e < (self.FrequencyEventDetails().length -1)){
       self.SelectedFrequencyEventDetail(e+1);
       self.ChangeInfoEvent();
    }
  });

  self.DecrementInfoEvent = ko.pureComputed(function(){
    let e = self.SelectedFrequencyEventDetail();
    if(e > 0){
       self.SelectedFrequencyEventDetail(e-1);
       self.ChangeInfoEvent();
    }
  });

  self.ChangeInfoEvent = ko.pureComputed(function(){    
    let ix = self.SelectedFrequencyEventDetail();
    var freqDetail = new FrequencyDataDetailed(self.FrequencyEventDetails()[ix], 0, self.MakeSelectionMask, [], true);      
        freqDetail.ApplyFilter(self.SelectionMask());
        freqDetail.OtherEquipmentActive = freqDetail.OtherEquipmentUses;
        freqDetail.OtherEquipmentThisAssigned = freqDetail.OtherEquipmentUses;
        self.InfoXCoord(screenX);
        self.InfoDetail(true);
        self.InfoFrequency(freqDetail);  
  });

  self.openTab = function(tabName) {
    $(".tabcontent").hide();
    $(".tablink").removeClass("selected");
    $("#freqBtn"+tabName).addClass("selected");
    $('#Frequencies'+tabName).show(); 
  }
  
  self.LoadInitial = function () {
    var currBitFlag = 1;
    self.AllActivities.forEach(function (a) {
      a.BitFlag = currBitFlag;
      currBitFlag <<= 1;
    });    
    self.GetEventFrequencies();    
  };

  self.GetEventFrequencies = function (keepSelectedSegmentAndZoom, message) {
    var params = {
      ids: self.EventIDs,
      segmentNum: self.SelectedSegmentInfo(),
      chartMinFreq: self.ChartMinFreq(),
      chartMaxFreq: self.ChartMaxFreq(),
      locationID: self.AllActivities.map(function (a) {
        return a.LocationID;
      }).join()
    };

    Common.BlockUI(message || '');
    $.post(RazorShared.baseUrl + 'EventFrequencies/GetAllEventsFrequencies/', params, function (data) {
      if (data.success) {
        self.ClearFrequencies();
        if (data.segmentList) self.EventFrequencyBlockSelector.LoadBlockSegments(data.segmentList, params.segmentNum, !keepSelectedSegmentAndZoom); //self.resetSelectedFreqBlockSegment()        
        self.SegmentsInfo(data.SegmentsInfo.Segments);
        self.FrequencyDataReceived(data.FrequenciesData, data.scanData, keepSelectedSegmentAndZoom); 
        self.LoadChart();       
        $.unblockUI();
      } else {
        $.unblockUI();
        Common.Dialog('Error retrieving frequency data', null, data.error);
      }
    }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
      $.unblockUI();
      Common.Dialog('Error retrieving frequency data', textStatus + '/' + errorThrown, null, XMLHttpRequest.status);
    });
  };
  
  self.IsHover = ko.pureComputed(function () {
    return !self.InfoDetail();
  });
  self.IsPinned = ko.pureComputed(function () {
    return self.InfoDetail();
  });
  self.IsDialog = false;
};

export default EventsAllFrequenciesVM
